import { Routes, Route } from 'react-router-dom';
import { Box } from '@mantine/core';
import Home from '@pages/Home';
import Signup from '@pages/Signup';
import ForgotPassword from '@pages/ForgotPassword';
import VolunteerRegister from '@pages/volunteer/Register';
import { Sign } from '@pages/volunteer/Sign';
import CreateAccount from '@pages/volunteer/CreateAccount';
import AccountCreated from '@pages/volunteer/AccountCreated';
import AppLayout from './layouts/AppLayout';
import PendingApprovalLayout from './layouts/PendingApprovalLayout';
import Dashboard from '@pages/app/Dashboard';
import PendingApproval from '@pages/app/PendingApproval';
import ProfileSettings from '@pages/app/ProfileSettings';
import PendingUsers from '@pages/app/admin/PendingUsers';
import Volunteers from '@pages/app/admin/Volunteers';
import VolunteerDetail from '@pages/app/admin/VolunteerDetail';
import ShiftPlanner from '@pages/app/ShiftPlanner';
import PublicLayout from './layouts/PublicLayout';

function App() {
  return (
    <>
      <Box pt={70}>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="signup" element={<Signup />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
          </Route>
          <Route path="/shift-planner-preview" element={<ShiftPlanner />} />
          <Route path="/volunteer" element={<PublicLayout />}>
            <Route path="register" element={<VolunteerRegister />} />
            <Route path="sign" element={<Sign />} />
            <Route path="create-account" element={<CreateAccount />} />
            <Route path="account-created" element={<AccountCreated />} />
          </Route>

          {/* Pending approval route (authenticated but not approved) */}
          <Route
            path="/app/pending-approval"
            element={<PendingApprovalLayout />}
          >
            <Route index element={<PendingApproval />} />
          </Route>

          {/* Protected routes under /app (require approval) */}
          <Route path="/app" element={<AppLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="calendar" element={<ShiftPlanner />} />
            <Route path="shift-planner" element={<ShiftPlanner />} />
            <Route path="profile" element={<ProfileSettings />} />
            <Route path="admin/pending-users" element={<PendingUsers />} />
            <Route path="admin/volunteers" element={<Volunteers />} />
            <Route
              path="admin/volunteers/:volunteerId"
              element={<VolunteerDetail />}
            />
          </Route>
        </Routes>
      </Box>
    </>
  );
}

export default App;
